define('directives/common/bi-analytic/bi-analytic.directive',['app'], function (app) {    
    app.directive('biAnalytic', ['$timeout', '$parse','biAnalyticService', function ($timeout, $parse, biAnalyticService, $event) {
        return {
            restrict: 'EA',
            link:function(scope, element, attrs) {
                element.on("click", function (event) {
                    if(attrs.serviceitem  && attrs.biname && attrs.tagtype){
                        if((attrs.biname.indexOf("预装") !=-1 && attrs.serviceitem ==40) || attrs.biname.indexOf("预装") ==-1){
                            biAnalyticService.bianalyticLink(attrs.biname, attrs.serviceitem, attrs.tagtype);
                        }
                    }else if(attrs.biname =="查看使用向导"){
                        biAnalyticService.bianalyticLink(attrs.biname, attrs.serviceitem, "DPRM0049");
                    }else if(attrs.biname =="查看客户支持"){
                        biAnalyticService.bianalyticLink(attrs.biname, attrs.serviceitem, "DPRM0048");
                    }else if(attrs.biname && attrs.tagtype){
                        biAnalyticService.bianalyticLink(attrs.biname, "1", attrs.tagtype);
                    }else{
                        biAnalyticService.bianalyticLink(attrs.biname,'1');
                    }
                });
            }
        };
    }]);
});

